import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function FAQPage() {
  const faqCategories = [
    {
      category: 'General Questions',
      questions: [
        {
          question: 'What areas do you serve in Pennsylvania?',
          answer: 'We proudly serve Allentown, Bethlehem, Easton, Nazareth, Forks Township, Wind Gap, Pen Argyl, Bangor, Bath, Whitehall, Northampton, Hellertown, Tatamy PA, and Phillipsburg NJ. Contact us if your area is not listed - we may still be able to help!'
        },
        {
          question: 'How far in advance should I book my event entertainment rental?',
          answer: 'We recommend booking 2-4 weeks in advance, especially for weekends and peak seasons (spring and summer). However, we offer same-day service when available for last-minute events. Call us at (610) 253-2835 to check availability.'
        },
        {
          question: 'What types of events do you cater to?',
          answer: 'We serve all types of events including birthday parties, corporate events, school functions, church festivals, community gatherings, graduation parties, family reunions, fundraisers, and more. No event is too big or too small!'
        }
      ]
    },
    {
      category: 'Safety & Cleanliness',
      questions: [
        {
          question: 'Are your bounce houses and equipment safe and clean?',
          answer: 'Absolutely! Safety is our top priority. All equipment is professionally cleaned and sanitized before and after each rental. We inspect every item for safety and maintain all equipment to the highest standards. We are fully licensed and insured for your peace of mind.'
        },
        {
          question: 'Do you have insurance and proper licensing?',
          answer: 'Yes, Fun Affairs is fully licensed and insured. We carry comprehensive liability insurance and meet all local and state requirements for event entertainment rental companies.'
        },
        {
          question: 'What safety measures do you take?',
          answer: 'We conduct thorough safety inspections before every rental, provide clear safety instructions, ensure proper anchoring and setup, and use only equipment that meets or exceeds industry safety standards.'
        }
      ]
    },
    {
      category: 'Pricing & Payment',
      questions: [
        {
          question: 'What is included in the rental price?',
          answer: 'Our rental prices include free delivery within our service area, professional setup, safety instructions, and pickup after your event. There are no hidden fees - we provide transparent, upfront pricing.'
        },
        {
          question: 'Do you require a deposit?',
          answer: 'Yes, we require a deposit to secure your reservation. The deposit amount varies based on your rental package. The remaining balance is due on the day of your event. We accept multiple payment methods including cash, check, and credit cards.'
        },
        {
          question: 'What is your cancellation policy?',
          answer: 'We understand that plans can change. Please contact us as soon as possible if you need to cancel or reschedule. Cancellation policies vary based on timing and circumstances. We work with you to find the best solution.'
        }
      ]
    },
    {
      category: 'Delivery & Setup',
      questions: [
        {
          question: 'Do you deliver and set up the equipment?',
          answer: 'Yes! Professional delivery, setup, and pickup are included with every rental. Our experienced crew handles everything so you can focus on enjoying your event.'
        },
        {
          question: 'How long does setup take?',
          answer: 'Setup time varies depending on the equipment and quantity, but typically takes 15-30 minutes per item. We arrive early to ensure everything is ready before your guests arrive.'
        },
        {
          question: 'What do I need to provide for setup?',
          answer: 'We need access to a standard electrical outlet for inflatables and a flat, clear area for setup. We\'ll discuss specific requirements when you book. For some items, we can provide generators if electricity is not available.'
        }
      ]
    },
    {
      category: 'Weather & Outdoor Events',
      questions: [
        {
          question: 'What happens if it rains on my event day?',
          answer: 'Weather policies vary by rental type. Many of our inflatables can be used in light rain, but we prioritize safety above all. Contact us to discuss weather concerns and rescheduling options. We work with you to ensure your event is successful.'
        },
        {
          question: 'Can bounce houses be used indoors?',
          answer: 'Yes! Many of our bounce houses and inflatables can be used indoors if you have adequate ceiling height and space. Contact us to discuss your indoor venue and we\'ll recommend appropriate equipment.'
        },
        {
          question: 'Do you provide equipment for winter events?',
          answer: 'Yes, we offer entertainment options suitable for indoor winter events. While some outdoor equipment is seasonal, we have plenty of indoor entertainment options available year-round.'
        }
      ]
    },
    {
      category: 'Equipment & Rentals',
      questions: [
        {
          question: 'Can I add more items to my rental after booking?',
          answer: 'Yes! You can add additional items to your rental based on availability. Contact us as soon as possible to discuss adding more entertainment options to make your event even more memorable.'
        },
        {
          question: 'Do you offer package deals?',
          answer: 'Yes, we offer package deals that combine multiple items at discounted rates. Contact us to discuss your event needs and we\'ll create a custom package that fits your budget.'
        },
        {
          question: 'How many children can use a bounce house at once?',
          answer: 'Capacity varies by bounce house size and model. We provide specific capacity guidelines for each unit to ensure safety. Generally, smaller units accommodate 4-6 children, while larger units can handle 8-12 children at a time.'
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <section className="py-24 bg-gradient-to-br from-red-600 to-orange-500">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-5xl sm:text-6xl font-bold text-white mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
              Frequently Asked Questions
            </h1>
            <p className="text-xl text-white/95 max-w-3xl mx-auto">
              Find answers to common questions about our event entertainment rentals, services, and policies.
            </p>
          </div>
        </section>

        <section className="py-24 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            {faqCategories.map((category, categoryIndex) => (
              <div key={categoryIndex} className="mb-16">
                <h2 className="text-3xl font-bold text-gray-900 mb-8" style={{ fontFamily: 'Sora, sans-serif' }}>
                  {category.category}
                </h2>
                <div className="space-y-4">
                  {category.questions.map((faq, index) => (
                    <details 
                      key={index}
                      className="group bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-xl overflow-hidden hover:border-red-200 transition-all"
                    >
                      <summary className="flex items-center justify-between p-6 cursor-pointer list-none">
                        <h4 className="text-base font-bold text-gray-900 pr-4">
                          {faq.question}
                        </h4>
                        <i className="ri-arrow-down-s-line text-2xl text-red-600 group-open:rotate-180 transition-transform flex-shrink-0"></i>
                      </summary>
                      <div className="px-6 pb-6">
                        <p className="text-sm text-gray-600 leading-relaxed">
                          {faq.answer}
                        </p>
                      </div>
                    </details>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="bg-white p-12 rounded-2xl shadow-xl border border-gray-200">
              <div className="w-20 h-20 flex items-center justify-center bg-red-600 rounded-2xl mx-auto mb-6">
                <i className="ri-question-answer-fill text-4xl text-white"></i>
              </div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Sora, sans-serif' }}>
                Still Have Questions?
              </h2>
              <p className="text-lg text-gray-600 mb-8">
                We're here to help! Contact us and our friendly team will be happy to answer any questions you have about our event entertainment rentals.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <Link 
                  to="/contact" 
                  className="bg-red-600 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-red-700 transition-colors whitespace-nowrap w-full sm:w-auto"
                >
                  Contact Us
                </Link>
                <a 
                  href="tel:6102532835" 
                  className="bg-gray-900 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-gray-800 transition-colors whitespace-nowrap w-full sm:w-auto"
                >
                  <i className="ri-phone-fill mr-2"></i>
                  (610) 253-2835
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}